import React from "react";
import { useNavigate } from "react-router-dom";
import {
  AnnouncementAction,
  AnnouncementActionType,
  Announcement
} from "../../../Contracts/Announcement";

interface AnnouncementTemplate1Props {
  readonly announcement: Announcement;
  readonly remindLater: () => void;
  readonly viewAnnouncement: () => void;
}

const AnnouncementTemplate1: React.FC<AnnouncementTemplate1Props> = ({
  announcement,
  remindLater,
  viewAnnouncement
}) => {
  const navigate = useNavigate();

  const checkElement = (action: AnnouncementAction) => {
    return new Promise<HTMLElement>((resolve, reject) => {
      const interval = setInterval(() => {
        const element = document.querySelector(action.value);
        if (element) {
          clearInterval(interval);
          if (element instanceof HTMLElement) {
            resolve(element);
          } else {
            reject(new Error("Element is not an HTMLElement"));
          }
        }
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
        reject(new Error("Element not found within 2 seconds"));
      }, 2000);
    });
  };

  const onViewAnnouncement = async () => {
    viewAnnouncement();
    for (const action of announcement.template_metadata.action_button.actions) {
      if (action.type === AnnouncementActionType.Navigate) {
        navigate(action.value);
      } else if (action.type === AnnouncementActionType.Click) {
        try {
          const element = await checkElement(action);
          element.click();
        } catch (error) {
          console.error((error as Error).message);
          break;
        }
      } else if (action.type === AnnouncementActionType.ExternalLink) {
        window.open(action.value, "_blank", "noopener,noreferrer");
      }
    }
  };

  return (
    <div>
      <div className="font-semibold text-lg mb-2">
        {announcement.template_metadata.title}
      </div>
      <div className="mb-4">{announcement.template_metadata.description}</div>
      <img
        className="mb-4 w-full"
        src={announcement.template_metadata.image_url}
        alt="announcement"
      />
      <div className="flex gap-4">
        {announcement.interactions_count === 0 && (
          <button
            className="flex-1 px-4 py-2 bg-gray-200 rounded"
            onClick={remindLater}
          >
            Remind me later
          </button>
        )}
        <button
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded"
          onClick={onViewAnnouncement}
        >
          {announcement.template_metadata.action_button.label}
        </button>
      </div>
    </div>
  );
};

export default AnnouncementTemplate1;
